import { createTheme } from '@mui/material/styles';

/** App shell colours shared with Studio (pages/playground/theme.ts). */
export const SHELL = {
  bg: '#0b1220',
  border: 'rgba(148,163,184,0.18)',
  /** Side nav: dark like the top bar and Studio, so the frame reads as one piece around light pages. */
  nav: '#0f172a',
  navText: '#cbd5e1',
  navMuted: '#94a3b8',
  navAccent: '#7dd3fc',
};

/** Drawer paper styles for the dark side nav. */
export const navPaperSx = {
  bgcolor: SHELL.nav,
  color: SHELL.navText,
  borderRight: `1px solid ${SHELL.border}`,
  '& .MuiListItemIcon-root': { color: SHELL.navMuted },
  '& .MuiDivider-root': { borderColor: SHELL.border },
  '& .MuiListSubheader-root': { color: '#64748b', bgcolor: SHELL.nav },
  '& .MuiListItemButton-root:hover': { bgcolor: 'rgba(148,163,184,0.12)' },
  '& a': { color: SHELL.navMuted },
};

const BORDER = '#e2e8f0';

/** The original theme, kept for the public chatbot embed so customers' widgets don't change. */
export const embedTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
  },
});

// shape.borderRadius stays at MUI's 4: pages use `borderRadius: n` in sx as a multiple of it,
// so radii are set per component below instead.
export const appTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#2563eb' },
    secondary: { main: '#4f46e5' },
    background: { default: '#edf1f6', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#475569' },
    divider: BORDER,
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiOutlinedInput: {
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 10 },
        elevation1: { boxShadow: '0 1px 2px rgba(15,23,42,0.06), 0 1px 3px rgba(15,23,42,0.08)' },
        elevation2: { boxShadow: '0 1px 3px rgba(15,23,42,0.08), 0 2px 6px rgba(15,23,42,0.06)' },
        elevation3: { boxShadow: '0 2px 4px rgba(15,23,42,0.08), 0 4px 12px rgba(15,23,42,0.06)' },
      },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 12 } },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 12 } },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: '#1e293b', fontSize: '0.75rem' },
        arrow: { color: '#1e293b' },
      },
    },
    MuiTableCell: {
      styleOverrides: { head: { fontWeight: 600 } },
    },
  },
});
